import { InputHTMLAttributes, LabelHTMLAttributes } from "react";
import { cn } from "@/lib/tailwind";
interface ISwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  bgClassName?: string;
  nodClassName?: string;
  label?: React.ReactNode;
  labelProps?: Omit<LabelHTMLAttributes<HTMLLabelElement>, "children">;
}

const Switch = ({
  label,
  bgClassName,
  nodClassName,
  labelProps = {},
  ...restProps
}: ISwitchProps) => {
  const { className: inputClassName, ...restInputProps } = restProps;
  const { className: labelClassname, ...restLabelProps } = labelProps;
  return (
    <fieldset
      disabled={restInputProps.disabled}
      className={cn(
        "flex items-center gap-[0.625rem] text-[0.813rem] font-normal text-black",
        restInputProps.disabled && "cursor-not-allowed opacity-70",
      )}
    >
      <label
        className={cn(
          "relative h-6 w-[2.625rem] cursor-pointer rounded-full bg-tertiary-3 transition [-webkit-tap-highlight-color:_transparent] has-[:checked]:bg-black",
          restInputProps.disabled && "cursor-not-allowed",
          bgClassName,
        )}
      >
        <input
          type="checkbox"
          className={cn(
            "peer sr-only",
            restInputProps.disabled && "cursor-not-allowed opacity-70",
            inputClassName,
          )}
          {...restInputProps}
        />
        <span
          className={cn(
            "absolute inset-y-0 start-0 m-1 mt-[0.285rem] size-[0.938rem] rounded-full bg-white transition-all peer-checked:start-5",
            nodClassName,
          )}
        />
      </label>
      {label && (
        <span
          {...restLabelProps}
          className={cn(restInputProps.disabled && "cursor-not-allowed opacity-70", labelClassname)}
        >
          {label}
        </span>
      )}
    </fieldset>
  );
};

export default Switch;
